import { getTickSize } from '../../utils/tickSizeUtils';

export function pointValueFromDetails(details) {
  const n = Number(details?.PriceFormat?.PointValue);
  return Number.isFinite(n) && n > 0 ? n : 1;
}

export function tickSizeFromDetails(ticker, details) {
  return getTickSize(ticker, details);
}
